var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    { attrs: { title: _vm.title } },
    [
      _c(
        "v-card",
        {
          staticClass: "ma-0 pa-2",
          attrs: { width: "100%", elevation: "0", outlined: "" },
        },
        [
          _c(
            "v-card-actions",
            {
              staticClass: "ma-0 pa-1",
              attrs: { width: "100%", elevation: "0" },
            },
            [
              _c(
                "v-card-title",
                { staticClass: "orange--text pa-0 ma-0 ml-1" },
                [_vm._v("Product Track")]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "green--text",
                  attrs: {
                    icon: "",
                    elevation: "0",
                    color: "white",
                    dense: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.row_add()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-plus")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "ma-0 pa-1",
              attrs: { width: "100%", elevation: "0" },
            },
            [
              _c("v-data-table", {
                staticStyle: { "white-space": "nowrap", width: "100%" },
                attrs: {
                  headers: _vm.headers,
                  items: _vm.value.products,
                  height:
                    _vm.value.products && _vm.value.products.length > 7
                      ? 32 * 7 + 32 + 16
                      : undefined,
                  "item-key": "none",
                  "disable-pagination": "",
                  "hide-default-footer": "",
                  dense: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.product",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.getProductName(item.product)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.points",
                    fn: function ({ item }) {
                      return [_vm._v(" " + _vm._s(item.points) + " ")]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item, index }) {
                      return [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.row_edit(index)
                              },
                            },
                          },
                          [_vm._v("mdi-pencil")]
                        ),
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.row_moveup(index)
                              },
                            },
                          },
                          [_vm._v("mdi-arrow-up-thick")]
                        ),
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.row_movedown(index)
                              },
                            },
                          },
                          [_vm._v("mdi-arrow-down-thick")]
                        ),
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.row_remove(index)
                              },
                            },
                          },
                          [_vm._v("mdi-delete")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(
                    _vm._s(
                      _vm.editIndex === -1 ? "Add Product" : "Edit Product"
                    )
                  ),
                ]),
              ]),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Points",
                      type: "number",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.editItem.points,
                      callback: function ($$v) {
                        _vm.$set(_vm.editItem, "points", _vm._n($$v))
                      },
                      expression: "editItem.points",
                    },
                  }),
                  _c("r-product-dropdown", {
                    attrs: {
                      model: _vm.editItem.product,
                      groups: _vm.product_groups,
                      label: "Product",
                      outlined: "",
                      dense: "",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.editItem, "product", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }